<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
        {{ title}}
    </h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-center">
    <img alt="{{title}}" width="400" height="400" src="{{pathImage}}">
</mat-dialog-content>